import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator/index';
import { withStyles, Chip } from '@material-ui/core';
import {
    Notifications as NotificationIcon,
    Devices as DeviceIcon,
    Settings as SettingsIcon,
    CalendarToday as PlanningIcon,
    Dashboard as DashboardIcon,
    Email as EmailIcon,
    EventNote as CguIcon
} from '@material-ui/icons';
import { SvgBox, SvgUser, SvgHome, SvgTicket, SvgCraftsman, SvgProduct, SvgManagement, SvgJournalisation } from 'data/common/iconsvg';

class LogChipCategory extends PureComponent {
    static propTypes = {
        category: PropTypes.string.isRequired,
        classes: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired
    };

    getDateFromCateg = () => {
        const { category, theme, classes } = this.props;
        switch (category) {
            case 'user':
                return {
                    icon: (
                        <div className={classes.chipIcon}>
                            <SvgUser size={15} color={theme.palette.common.white} />
                        </div>
                    ),
                    label: Translator.translate('logging.category.user')
                };
            case 'home':
                return {
                    icon: (
                        <div className={classes.chipIcon}>
                            <SvgHome size={12} color={theme.palette.common.white} />
                        </div>
                    ),
                    label: Translator.translate('logging.category.home')
                };
            case 'box':
                return {
                    icon: (
                        <div className={classes.chipIcon}>
                            <SvgBox size={15} color={theme.palette.common.white} />
                        </div>
                    ),
                    label: Translator.translate('logging.category.box')
                };
            case 'userManager':
                return {
                    icon: (
                        <div className={classes.chipIcon}>
                            <SvgUser size={15} color={theme.palette.common.white} />
                        </div>
                    ),
                    label: Translator.translate('logging.category.userManager')
                };
            case 'ticket':
                return {
                    icon: (
                        <div className={classes.chipIcon}>
                            <SvgTicket size={12} color={theme.palette.common.white} />
                        </div>
                    ),
                    label: Translator.translate('logging.category.ticket')
                };
            case 'craftsman':
                return {
                    icon: (
                        <div className={classes.chipIcon}>
                            <SvgCraftsman size={15} color={theme.palette.common.white} />
                        </div>
                    ),
                    label: Translator.translate('logging.category.craftsman')
                };
            case 'installer':
                return {
                    icon: (
                        <div className={classes.chipIcon}>
                            <SvgCraftsman size={15} color={theme.palette.common.white} />
                        </div>
                    ),
                    label: Translator.translate('logging.category.installer')
                };
            case 'product':
                return {
                    icon: (
                        <div className={classes.chipIcon}>
                            <SvgProduct size={15} color={theme.palette.common.white} />
                        </div>
                    ),
                    label: Translator.translate('logging.category.product')
                };
            case 'history':
                return {
                    icon: (
                        <div className={classes.chipIcon}>
                            <SvgTicket size={12} color={theme.palette.common.white} />
                        </div>
                    ),
                    label: Translator.translate('logging.category.history')
                };
            case 'management':
                return {
                    icon: (
                        <div className={classes.chipIcon}>
                            <SvgManagement size={12} color={theme.palette.common.white} />
                        </div>
                    ),
                    label: Translator.translate('logging.category.management')
                };
            case 'notifications':
                return {
                    icon: <NotificationIcon className={classes.chipIcon} />,
                    label: Translator.translate('logging.category.notifications')
                };
            case 'device':
                return {
                    icon: <DeviceIcon className={classes.chipIcon} />,
                    label: Translator.translate('logging.category.device')
                };
            case 'settings':
                return {
                    icon: <SettingsIcon className={classes.chipIcon} />,
                    label: Translator.translate('logging.category.settings')
                };
            case 'planning':
                return {
                    icon: <PlanningIcon className={classes.chipIcon} />,
                    label: Translator.translate('logging.category.planning')
                };
            case 'account':
                return {
                    icon: (
                        <div className={classes.chipIcon}>
                            <SvgUser size={15} color={theme.palette.common.white} />
                        </div>
                    ),
                    label: Translator.translate('logging.category.account')
                };
            case 'dashboard':
                return {
                    icon: <DashboardIcon className={classes.chipIcon} />,

                    label: Translator.translate('logging.category.dashboard')
                };
            case 'journalisation':
                return {
                    icon: (
                        <div className={classes.chipIcon}>
                            <SvgJournalisation size={12} color={theme.palette.common.white} />
                        </div>
                    ),
                    label: Translator.translate('logging.category.journalisation')
                };
            case 'mail':
                return {
                    icon: <EmailIcon className={classes.chipIcon} />,
                    label: Translator.translate('logging.category.mail')
                };
            case 'cgu':
                return {
                    icon: <CguIcon className={classes.chipIcon} />,
                    label: Translator.translate('logging.category.cgu')
                };
            case 'pushNotification':
                return {
                    icon: (
                        <div className={classes.chipIcon}>
                            <SvgTicket size={15} color={theme.palette.common.white} />
                        </div>
                    ),
                    label: Translator.translate('logging.category.pushNotification')
                };
            default:
                return {
                    icon: null,
                    label: ''
                };
        }
    };

    render() {
        const { classes, category } = this.props;
        const categObject = this.getDateFromCateg();

        return <Chip size="small" icon={categObject.icon} label={categObject.label} className={classes[category]} />;
    }
}

const styles = theme => ({
    chipIcon: {
        color: theme.palette.common.white,
        marginLeft: 6,
        marginBottom: 1
    },
    user: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c001
    },
    home: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c002
    },
    box: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c003
    },
    userManager: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c004
    },
    ticket: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c005
    },
    craftsman: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c006
    },
    installer: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c006
    },
    product: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c007
    },
    history: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c008
    },
    management: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c009
    },
    notifications: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c010
    },
    device: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c011
    },
    settings: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c012
    },
    planning: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c013
    },
    account: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c014
    },
    dashboard: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c015
    },
    journalisation: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c016
    },
    mail: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c017
    },
    cgu: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c018
    },
    pushNotification: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c019
    }
});

export default withStyles(styles, { withTheme: true })(LogChipCategory);



// WEBPACK FOOTER //
// ./data/components/LogChipCategory.js